import { Link } from "react-router-dom";
import { foodHighlights, siteStats } from "@/mocks/site";

export default function HighlightSection() {
  return (
    <section className="bg-background-50">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-2 gap-4 rounded-lg border border-background-200 bg-primary-50 p-6 md:grid-cols-4 md:gap-6 md:p-8">
          {siteStats.map((s) => (
            <div key={s.label} className="text-center">
              <p className="font-heading text-2xl font-extrabold text-primary-600 md:text-3xl">{s.value}</p>
              <p className="mt-1 text-xs text-foreground-600 md:text-sm">{s.label}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-3">
          {foodHighlights.map((h) => (
            <div
              key={h.title}
              className="flex gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition hover:border-primary-300"
            >
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                <i className={`${h.icon} text-2xl`} />
              </span>
              <div>
                <h3 className="font-heading text-base font-bold text-foreground-950">{h.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-500">{h.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link
            to="/food-category"
            className="flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 transition hover:bg-primary-600"
          >
            <i className="ri-restaurant-2-line" />
            浏览全部美食
          </Link>
          <Link
            to="/courier"
            className="flex items-center gap-2 whitespace-nowrap rounded-full border border-accent-300 bg-accent-50 px-6 py-3 text-sm font-bold text-accent-700 transition hover:bg-accent-100"
          >
            <i className="ri-e-bike-2-line" />
            了解快递服务
          </Link>
        </div>
      </div>
    </section>
  );
}